import { AlertInformationType } from 'moduleBase/components/alert-information/types/AlertInformationType';
import React, { FC, useEffect, useState } from 'react';
import { AlertInformation } from 'moduleBase/components/alert-information/AlertInformation';
import { useLocation } from 'react-router';
import app from 'srcJs/App';

type PropTypes = {
  alerts: AlertInformationType[];
};

const AlertInformationList: FC<PropTypes> = ({
  alerts,
}) => {
  const [filteredAlerts, setFilteredAlerts] = useState<AlertInformationType[]>(alerts);
  const location = useLocation();

  useEffect(() => {
    let pathNameWithoutLang = location.pathname;
    const langForPathname = `/${app.getLang()}`;
    if (location.pathname.startsWith(langForPathname)) {
      pathNameWithoutLang = location.pathname.substring(langForPathname.length);
    }

    setFilteredAlerts(() => alerts.filter((alert) => {
      if (!alert.pages) {
        return true;
      }
      return alert.pages.some((page) => page === pathNameWithoutLang);
    }));
  }, [location.pathname]);

  const list = filteredAlerts.map((alert) => (
    <React.Fragment key={alert.key}>
      <AlertInformation
        keyProp={alert.key}
        content={alert.content}
        variant={alert.variant}
        closeUrl={alert.closeUrl}
        modalHeader={alert.modalHeader}
        modalContent={alert.modalContent}
        modalKey={alert.modalKey}
        leftButtonText={alert.leftButtonText}
        leftButtonUrl={alert.leftButtonUrl}
        rightButtonText={alert.rightButtonText}
        rightButtonUrl={alert.rightButtonUrl}
      />
    </React.Fragment>
  ));

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {list}
    </>
  );
};

export { AlertInformationList };
